import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=c6bac484"
import script from "./changePwd.vue?vue&type=script&lang=js"
export * from "./changePwd.vue?vue&type=script&lang=js"
import style0 from "./changePwd.vue?vue&type=style&index=0&id=c6bac484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports